<template>
  <div >
    <div id="fourColorEchart"></div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "fourColorEcharts",
  props: {
    echartsData: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  data() {
    return {
      myChart: {},
      interval: null,
      chartType: false //true自动轮播  false手动拖拽
    };
  },
  created() {
    // this.$nextTick(() => {
    //   this.loadEchart();
    // });
  },
  mounted() {
    this.loadEchart();
  },
  methods: {
    chartTypeCut() {
      this.chartType = !this.chartType;
      
    this.loadEchart();
    },
    loadEchart() {
      let colors = this.$store.state.select.riskLevel.map((item) => {
        return item.backgroundColor;
      });
      this.myChart = Echarts.init(document.getElementById("fourColorEchart"));
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          orient: "horizontal",
          left: "center",
          bottom: "0",
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 40,
          bottom: 10,
          textStyle: {
            color: "#C4CDFF"
          },
          data: ["低风险", "一般风险", "较大风险", "重大风险"]
        },
        grid: {
          top: 60,
          left: "3%",
          right: "4%",
          bottom: '13%',
          containLabel: true
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#D0D8FF"
            }
          }
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#D0D8FF"
            }
          },
          axisLabel: {
            interval: 0,
            formatter: function(params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的个数
              var provideNumber = 5; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 计算行数，向上取整 //判断是否需要换行
              if (paramsNameNumber > provideNumber) {
                //循环得到每行的显示内容，p代表行
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              return newParamsName;
            }
          }
          // data:['1','2','3','4','5','6','7']
        },
        toolbox: {
          show: false,
          orient: "vertical",
          right: "10px",
          top: "25px",
          feature: {
            saveAsImage: {}
          }
        },
        dataZoom: [
          {
            show: false,
            textStyle: {
              color: "rgba(255,255,255,0)"
            },
            type: "inside",
            xAxisIndex: [0],
            left: "5%",
            bottom: 0,
            start: 0,
            end: 100 //初始化滚动条
          }
        ],
        series: [
          {
            name: "低风险",
            type: "bar",
            barMaxWidth: 20,
            stack: "总量",
            label: {
              normal: {
                textStyle: {
                  color: "#C4CDFF"
                }
              }
            },
            label: {
              show: false, //是否显示标签
              position: "insideRight"
            },
            itemStyle: {
              normal: {
                borderColor: "#23378E",
                borderWidth: 1,
                barBorderRadius: [3]
              }
            }
          },
          {
            name: "一般风险",
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "insideRight"
            },
            itemStyle: {
              normal: {
                borderColor: "#23378E",
                borderWidth: 1,
                barBorderRadius: [3]
              }
            }
          },
          {
            name: "较大风险",
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "insideRight"
            },
            itemStyle: {
              normal: {
                borderColor: "#23378E",
                borderWidth: 1,
                barBorderRadius: [3]
              }
            }
          },
          {
            name: "重大风险",
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "insideRight"
            },
            itemStyle: {
              normal: {
                borderColor: "#23378E",
                borderWidth: 1,
                barBorderRadius: [3]
              }
            }
          }
        ],
        color: colors
      };

        option.dataZoom[0].end = (6/this.echartsData.length)*100;
        option.xAxis.data = this.echartsData.map((item) => {
          return item.riskName;
        });
        // 重大风险
        option.series[3].data = this.echartsData.map((item) => {
          if (item.riskValue > 320) {
            return item.riskValue - 320;
          } else {
            return 0;
          }
        });
        option.series[2].data = this.echartsData.map((item) => {
          if (item.riskValue <= 320 && item.riskValue > 160) {
            return item.riskValue - 160;
          } else if (item.riskValue <= 160) {
            return 0;
          } else {
            return 160;
          }
        });
        option.series[1].data = this.echartsData.map((item) => {
          if (item.riskValue <= 160 && item.riskValue > 70) {
            return item.riskValue - 70;
          } else if (item.riskValue <= 70) {
            return 0;
          } else {
            return 90;
          }
        });
        option.series[0].data = this.echartsData.map((item) => {
          if (item.riskValue <= 70 && item.riskValue > 0) {
            return item.riskValue;
          } else if (item.riskValue <= 0) {
            return 0;
          } else {
            return 70;
          }
        });
        this.myChart.setOption(option, true);
    },
  },
  watch: {
    echartsData: function(nval) {
      clearInterval(this.interval);
      this.loadEchart();
    }
  }
};
</script>

<style scoped lang="scss">
#fourColorEchart {
  width: 100%;
  height: 250px;
}
</style>
